import config from '@config';

import createDataSource from '../createDataSource';
import { getDefaultEmptyList } from '../utils';

const BASE_PATHNAME = 'audiences';

export default () => {
  const dataSource = createDataSource(`${config.api.url}`);

  return {
    getList: async () => dataSource.get(`${BASE_PATHNAME}/`).json(),

    getSegments: async ({ id }) => dataSource.get(`${BASE_PATHNAME}/${id}/segments`).json(),

    getEmptyList: getDefaultEmptyList,
  };
};
